/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EmptyResponse } from '../../models/empty-response';
import { RecipientsDto } from '../../models/recipients-dto';

export interface OrderCustomerControllerSendEmail$Params {
  id: number;
      body: RecipientsDto
}

export function orderCustomerControllerSendEmail(http: HttpClient, rootUrl: string, params: OrderCustomerControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, orderCustomerControllerSendEmail.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

orderCustomerControllerSendEmail.PATH = '/order-customer/{id}/send-email';
